import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * CsvダウンロードYahooWordサービス
 */
export class CsvDownloadYahooWord {
  constructor(
    private Restangular: IService,
    private $q: ng.IQService,
    private $filter: any
  ) {}

  /**
   * Yahoo!検索ワード一覧をCSVとしてダウンロード
   * @param {string} rankType ランクの種別
   * @param {object} getOptions フィルタリングの要件
   * @return {function} 検索ワード一覧のCSVデータをPromiseとしてリターン
   */
  public download(rankType, getOptions) {
    const deferred = this.$q.defer()
    const csvData = []

    // データを全件ダウンロードするため、LIMITを外す
    getOptions.limit = null

    const requestUrl = `yahooword/getYahooWord?rank_type=${rankType}&get_options=${JSON.stringify(
      getOptions
    )}`

    // データを取得し、検索ワードごとにデータを整形して配列に格納する
    this.Restangular.all(requestUrl)
      .getList()
      .then((response) => {
        if (response[0].data !== null) {
          const yahooWords = response[0].data.yahooWordData

          // ランキングの種別によって、格納するデータの種類をわける
          if (rankType === 'burst') {
            const dataHeader = ['日付', '順位', '検索ワード', '説明文', 'スコア']

            csvData.push(dataHeader)

            yahooWords.forEach((data) => {
              const trendWordData = [
                data.date,
                data.ranking,
                data.keyword,
                data.description,
                data.score,
              ]
              csvData.push(trendWordData)
            })

            deferred.resolve(csvData)
          }

          if (rankType === 'people' || rankType === 'total') {
            const dataHeader = ['日付', '順位', '先週との比較', '検索ワード']

            csvData.push(dataHeader)

            yahooWords.forEach((data) => {
              const trendWordData = [data.date, data.ranking, data.type, data.keyword]
              csvData.push(trendWordData)
            })

            deferred.resolve(csvData)
          }
        }
      })

    // promiseとしてリターンする
    return deferred.promise
  }
}

// CSVダウンロード用のサービスを定義
app.service('CsvDownloadYahooWord', CsvDownloadYahooWord)
